import { useMemo } from 'react'

import type {
  DashboardLayout,
  LocalEdits,
  TempLayout,
} from '@pages/IntroducingBroker/DashboardPoC/types'
import { getSystemLayout } from '@pages/IntroducingBroker/DashboardPoC/utils/getSystemLayout'

export function useResolvedLayout(
  layouts: DashboardLayout[],
  currentLayoutId: string,
  tempLayout: TempLayout | null,
  localEdits: LocalEdits | null
): DashboardLayout | null {
  return useMemo(() => {
    if (tempLayout) {
      return {
        id: 'temp',
        name: tempLayout.name,
        description: tempLayout.description,
        isPreset: false,
        widgets: tempLayout.widgets,
        isDefault: tempLayout.isDefault,
      }
    }

    const layout = layouts.find(({ id }) => id === currentLayoutId) ?? getSystemLayout(layouts)

    if (!layout) {
      return null
    }

    if (localEdits?.layoutId === layout.id) {
      return {
        ...layout,
        name: localEdits.name ?? layout.name,
        description: localEdits.description ?? layout.description,
        widgets: localEdits.widgets,
      }
    }

    return layout
  }, [layouts, currentLayoutId, tempLayout, localEdits])
}
